import * as React from 'react';
import {Badge} from '@packages/systems/spring';
import {emotionStyled} from '@packages/utilities/styled';

type BaseBadgeProps = Omit<
  React.ComponentProps<typeof SubtleBadge>,
  'children'
>;

/**
 * Shared "Base" breakpoint badge used to indicate Base frames in Multi-Context Canvas.
 */
export const BaseBadge = ({
  colorVariant = 'default',
  ...rest
}: BaseBadgeProps) => (
  <SubtleBadge colorVariant={colorVariant} {...rest}>
    Base
  </SubtleBadge>
);

const SubtleBadge = emotionStyled(Badge)(
  {},
  {
    variants: {
      colorVariant: {
        default: {
          background: '$backgroundRaised',
        },
      },
    },
  }
);
